/* eslint-disable no-console */

import { RBIEnv, minDevLogLevel } from 'utils/environment';

import { LoggerChannel, LoggerChannelContext, LoggerEvent } from './types';

/**
 * Local console channel. Its enablement and filtering are completely
 * independent from remote (Datadog) delivery, so `logger.info` can be used for
 * local-only diagnostics without leaking to Datadog.
 */
export const consoleChannel: LoggerChannel = {
  isEnabled: ({ currentEnv }: LoggerChannelContext) => currentEnv === RBIEnv.DEV || __DEV__,
  isEligible: (event: LoggerEvent) => event.level >= minDevLogLevel(),
  deliver: ({ method, message }: LoggerEvent) => {
    // Resolve the console method at call time so it always uses the current
    // `console` (matching the previous inline behavior and remaining spy-able).
    switch (method) {
      case 'debug':
        console.log(message);
        break;
      case 'info':
        console.info(message);
        break;
      case 'warn':
        console.warn(message);
        break;
      case 'trace':
        console.trace(message);
        break;
      case 'error':
      default:
        console.error(message);
        break;
    }
  },
};
